<template>
	<v-content class="icoev-bk-color">
		<v-content fluid style="position: fixed;
    padding: 0px;
    /* height: calc(100vh - 171px); 
    overflow: hidden auto;*/
    top: 0px; 
    bottom: 50px;
    left: 0px;
    right: 0px; overflow: hidden auto;" class="fixNotchMarginTop fixNotchPaddingBottom">			
      <keep-alive>
				<router-view 
					@open-alerts-dialog="openAlertsDialog($event)" 
					@open-formacion-dialog="openFormacionDialog($event)" 
					@open-external-content="openUrl(arguments)" 
					@open-clinic-dialog="openClinicDialog(arguments)" 
					@alert-event="doShowAlert">
				</router-view>
      </keep-alive>
		</v-content>

		<v-row>
			<v-col class="mx-auto" cols="12">
				<AlertsDialog ref='dlgAlerts' @open-external-content="openUrl(arguments)"/>
				<FormacionDialog ref='dlgFormacion' @open-external-content="openUrl(arguments)"/>
				<ExternalContentDialog ref='dlgExternalContent' @open-external-content="openUrl(arguments)"/>
				<ClinicDialog ref='dlgClinic'/>
			</v-col>
		</v-row>

		<!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
		<v-snackbar
			v-model="showAlert"
			:timeout="alertTimeout"
			:color="alertColor">
				{{ alertText ? alertText.split('@')[0] : '' }}
				<v-btn v-if="alertColor != 'info'" text @click="showAlert=false">
					Cerrar
				</v-btn>
				<v-btn v-if="alertColor == 'info'" text @click.stop="goToSection(alertText.split('@')[1])">
					Ir
				</v-btn>
		</v-snackbar>
		<!-- FIN BLOQUE ESTADO PETICIONES -->

        <Footer ref='footer'/>
  </v-content>
</template>

<script>
import BaseModule from "../../common/BaseModule";
import Footer from './Footer';
import AlertsDialog from '../../common/AlertsDialog';
import FormacionDialog from '../../common/FormacionDialog';
import ExternalContentDialog from '../../common/ExternalContentDialog';
import ClinicDialog from '../../common/ClinicDialog';

export default {
	name: "MainMain",
	mixins: [ BaseModule ],
	components: {
		Footer, 
		AlertsDialog, 
		FormacionDialog, 
		ExternalContentDialog,
		ClinicDialog
	},
	data() {
		return {
			search: '',
			isLoading: false,
			showAlert: false,
			alertColor: 'error',
			alertText: '',
			alertTimeout: 3000,
		};
	},
	mounted: function() {
		this.$nextTick(() => {
			window.$vue.$on('notification-received', this.notificationReceived);

			window.$vue.$off('ne_backbutton');
			window.$vue.$on('ne_backbutton', this.processBackButton);
		});
	},
	methods: {		
		notificationReceived: function(section) {
			this.$log.debug("notification received! [ section: " + section + " ]");

			var text;	
			
			switch (section) {
				case 0: text = "Se ha recibido una noticia nueva"; break;
				case 1: text = "Se ha recibido una alerta sanitaria nueva"; break;
				case 2: text = "Se ha recibido una oferta/demanda nueva"; break;
				case 3: text = "Se ha recibido un curso nuevo"; break;
				case 4: text = "Se ha añadido una clínica nueva"; break;
			}

			text += '@' + section;

			this.doShowAlert({ text: text, color: 'info', timeout: 15000 });
		},
		goToSection(section) {
			this.$log.debug("goToSection() called! [ section: " + section + " ]");

			this.showAlert = false;
							
			//this.$log.debug("dlgAlerts isOpen: " + this.$refs.dlgAlerts.isOpen());

			//if (this.$refs.dlgAlerts.isOpen()) {
				this.$log.debug("dlgAlerts closed!");
				this.$refs.dlgAlerts.close();
			//}

			//if (this.$refs.dlgFormacion.isOpen()) {
				this.$log.debug("dlgFormacion closed!");
				this.$refs.dlgFormacion.close();
			//}
							
			//this.$log.debug("dlgExternalContent isOpen: " + this.$refs.dlgExternalContent.isOpen());

			//if (this.$refs.dlgExternalContent.isOpen()) {
				this.$log.debug("dlgExternalContent closed!");
				this.$refs.dlgExternalContent.close();
			//}

			//if (this.$refs.dlgClinic.isOpen()) {
				this.$log.debug("dlgClinic closed!");
				this.$refs.dlgClinic.close();
			//}
			
			this.$router.push({ name: 'main' });
			
			//Resfrescamos siempre la home
			if (section != '1') {
				this.$router.push({ name: 'home', params: { refresh: true } });
			}

			switch (parseInt(section)) {
				case 0:
					this.$router.push({ name: 'newsletter', params: { redirect: true } });
					break;
				case 1: 
					this.$router.push({ name: 'home', params: { redirect: true, refresh: true } });
					break;
				case 2: 
					this.$router.push({ name: 'bolsa-trabajo', params: { redirect: true } });
					break;
				case 3: 	
					this.$refs.dlgFormacion.open();
					//this.$router.push({ name: 'formacion', params: { redirect: true } });
					break;
				case 4: 
					this.$router.push({ name: 'tramites', params: { redirect: true } });
					break;
			}
		},
		processBackButton: function() {
			if (this.$refs.dlgAlerts.isOpen()) {
        this.$refs.dlgAlerts.close();
      } else if (this.$refs.dlgExternalContent.isOpen()) {
        this.$refs.dlgExternalContent.close();
      } else if (this.$refs.dlgClinic.isOpen()) {
        this.$refs.dlgClinic.close();
      }
		},
		openAlertsDialog: function(clearCache) {
			if (this.$refs.dlgAlerts.isOpen()) {
				return;
			}
			this.$refs.dlgAlerts.open(clearCache);
		},
		openFormacionDialog: function() {
			if (this.$refs.dlgFormacion.isOpen()) {
				return;
			}
			this.$refs.dlgFormacion.open();
		},
		openClinicDialog: function(args) {
			if (this.$refs.dlgClinic.isOpen()) {
				return;
			}

			var clinic = args[0];
			var msgCb = args[1];

			var clinicToEdit = this.$store.state.icoev.editedClinics.find(x => x.clinic.id == clinic.id);

			this.$refs.dlgClinic.open(clinicToEdit && !clinicToEdit.deleted ? clinicToEdit.clinic : clinic, (editedClinic) => {		
				if (msgCb) {
					msgCb(clinic, editedClinic);
				}
			});
		},
		doShowAlert: function(payload) {
				this.alertText = payload.text;
				this.alertColor = payload.color;
				this.alertTimeout = payload.timeout;
				this.showAlert = true;
		},
		openUrl: function(args) {
			this.$refs.dlgExternalContent.open(args);
		},
	},
}
</script>